import vuexI18n from 'vuex-i18n'
import config from './config'
import constant from './constant'
import api from './modules/api'
import auth from './modules/auth'
import home from './modules/home'
import moral from './modules/moral'
import profile from './modules/profile'
import proposeList from './modules/propose-list'
import proposeDetail from './modules/propose-detail'
import proposeEdit from './modules/propose-edit'
import proposeNew from './modules/propose-new'
import good from './modules/good'
import message from './modules/message'
import requestHoliday from './modules/request-holiday'
import shift from './modules/shift'
import willMust from './modules/will-must'
import documentRenewal from './modules/document-renewal'
import payroll from './modules/payroll'
import onboarding from './modules/onboarding'
import proposeTask from './modules/propose-task'
import proposeNotice from './modules/propose-notice'
import referral from './modules/referral'
import introduction from './modules/introduction'
import stepup from './modules/stepup'
import cards from './modules/cards'
import companyNotice from './modules/company-notice'
import usertype from './modules/usertype'
import shop from './modules/shop'
import stockShopmasterNotice from './modules/stock-shopmaster-notice'
import evaluateAnswer from './modules/evaluate-answer'
import serviceAnswer from './modules/service-answer'
import safetyConfirmation from './modules/safety-confirmation'

export default {
  state: {
    error: '',
    config: config,
    constant: constant
  },
  getters: {
    error: state => {
      return state.error
    },
    isSystemManagement: state => {
      var userAuthority = state.auth.user.userAuthority
      if (!userAuthority) {
        userAuthority = window.localStorage.getItem('user_authority')
      }
      return userAuthority === state.constant.userAuthority.system_management
    },
    isAppIncluding: state => {
      var userAuthority = state.auth.user.userAuthority
      if (!userAuthority) {
        userAuthority = window.localStorage.getItem('user_authority')
      }
      return userAuthority === state.constant.userAuthority.application_including
    },
    isAppNotIncluded: state => {
      var userAuthority = state.auth.user.userAuthority
      if (!userAuthority) {
        userAuthority = window.localStorage.getItem('user_authority')
      }
      return userAuthority === state.constant.userAuthority.application_not_included
    },
    isBrowsIncluding: state => {
      var userAuthority = state.auth.user.userAuthority
      if (!userAuthority) {
        userAuthority = window.localStorage.getItem('user_authority')
      }
      return userAuthority === state.constant.userAuthority.browsing_including
    },
    isShopMaster: state => {
      var isShopMaster = state.auth.user.shopMaster
      if (!isShopMaster) {
        isShopMaster = window.localStorage.getItem('is_shop_master')
      }
      return isShopMaster === state.constant.isShopMaster.boss
    }
  },
  modules: {
    api: api,
    i18n: vuexI18n.store,
    auth: auth,
    home: home,
    moral: moral,
    profile: profile,
    proposeList: proposeList,
    proposeDetail: proposeDetail,
    proposeEdit: proposeEdit,
    proposeNew: proposeNew,
    good: good,
    message: message,
    requestHoliday: requestHoliday,
    shift: shift,
    willMust: willMust,
    documentRenewal: documentRenewal,
    payroll: payroll,
    onboarding: onboarding,
    proposeTask: proposeTask,
    proposeNotice: proposeNotice,
    referral: referral,
    introduction: introduction,
    stepup: stepup,
    cards: cards,
    companyNotice: companyNotice,
    usertype: usertype,
    shop: shop,
    stockShopmasterNotice: stockShopmasterNotice,
    evaluateAnswer: evaluateAnswer,
    serviceAnswer: serviceAnswer,
    safetyConfirmation: safetyConfirmation
  }
}



// WEBPACK FOOTER //
// ./src/store/index.js